import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";


export const useFetchEmployeeCaseReport = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/employeeCaseReport/list`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};

export const useFetchEmployeeCaseReportInput = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const endPoint = `/api/v1/employeeCaseReport/input/list`;
      return await POST(endPoint, payload ,{
        timeout: 10000,
      });
    }
  });
};


